import { store } from './stores/mainStore';

export class MiddleLayer {
	constructor(connection, r7Data) {
		this.connection = connection;
		this.r7Data = r7Data;
	}

	Login() {
		const {ftue, ...serverAcceptable} = this.r7Data;
		return this.connection.CallRoute('auth/login', serverAcceptable)
	}

	GetMe() {
		return this.connection.CallRoute('me', {}, 'GET')
	}
	GetBalance() {
		return this.connection.CallRoute('me/balance', {}, 'GET')
	}
	GetPatterns() {
		return this.connection.CallRoute('bonus-game-patterns', {}, 'GET')
	}
	GetPaytable() {
		return this.connection.CallRoute('paytable', {}, 'GET')
	}

	CheckOngoing () {
		return this.connection.CallRoute('ongoing-game', {}, 'GET')
	}
	SendSeen () {
		return this.connection.CallRoute('seen-game', {}, 'PUT')
	}

	ResetTutorial(tutorial) {
		this.tutorialConnection = tutorial;
	}
	FinishTutorial(pay) {
		return Promise.resolve();
	}

	CreateMatch = (bet, rebet, patternId) => {
		/* if(window.location.hostname === "localhost") {	// 4oak
			return Promise.resolve({
				stakeAmount: 10,
				startedAt: 1770314535142,
				bonusGamePattern: {
					pattern: [1, 3, 4, 5, 7],
					createdAt: 1763565001848,
					id: 'ec81b655-fa41-4956-9382-f2a0561e141b',
					order: 1,
					updatedAt: 1763565001848,
				},
				deck: {
					faces: ['5c', '8s', '9d', '2s', '8c', '8d', 'Jd', '8h', 'Td'],
					indexes: [2, 4, 3, 0, 2, 4, 4, 2, 3],
				},
				remainingRolls: 0,
				result: 'win',
				prizeAmount: 40,
				bonusGameData: {
					freeGamesData: [
						{
							rounds: [
								{
									round: 1,
									blownIndexes: [5, 4, 8, 7, 1],
									beforeFaces: ['5c', '3d', 'Jh', '9s', 'Qd', 'Xj', '9c', '7d', 'Td'],
									beforeIndexes: [2, 2, 4, 2, 4, 0, 3, 1, 3],
									afterFaces: ['5c', '3d', '8d', '9s', '5h', '9h', '9c', '2h', 'Jh'],
									afterIndexes: [2, 2, 4, 2, 1, 2, 3, 0, 4],
									movements: [
										{
											from: 5,
											to: null,
											face: 'Xj',
											diceRow: 2,
											faceIndex: 0,
											type: 'removed',
										},
										{
											from: 4,
											to: null,
											face: 'Qd',
											diceRow: 4,
											faceIndex: 4,
											type: 'removed',
										},
										{
											from: 8,
											to: null,
											face: 'Td',
											diceRow: 5,
											faceIndex: 3,
											type: 'removed',
										},
										{
											from: 7,
											to: null,
											face: '7d',
											diceRow: 7,
											faceIndex: 1,
											type: 'removed',
										},
										{
											from: 1,
											to: null,
											face: '3d',
											diceRow: 1,
											faceIndex: 2,
											type: 'removed',
										},
										{
											from: null,
											to: 7,
											face: '2h',
											diceRow: 7,
											faceIndex: 0,
											type: 'spawned',
										},
										{
											from: null,
											to: 4,
											face: '5h',
											diceRow: 4,
											faceIndex: 1,
											type: 'spawned',
										},
										{
											from: null,
											to: 1,
											face: '3d',
											diceRow: 1,
											faceIndex: 2,
											type: 'spawned',
										},
										{
											from: 2,
											to: 8,
											face: 'Jh',
											diceRow: 8,
											faceIndex: 4,
											type: 'moved',
										},
										{
											from: null,
											to: 5,
											face: '9h',
											diceRow: 5,
											faceIndex: 2,
											type: 'spawned',
										},
										{
											from: null,
											to: 2,
											face: '8d',
											diceRow: 2,
											faceIndex: 4,
											type: 'spawned',
										},
									],
									payout: 10,
									name: 'flush',
									goalCode: 6,
								},
								{
									round: 2,
									blownIndexes: [3, 5, 6, 0, 4],
									beforeFaces: ['5c', '3d', '8d', '9s', '5h', '9h', '9c', '2h', 'Jh'],
									beforeIndexes: [2, 2, 4, 2, 1, 2, 3, 0, 4],
									afterFaces: ['Js', 'Jc', '9d', '9s', '3d', '8d', '3h', '2h', 'Jh'],
									afterIndexes: [4, 4, 3, 2, 2, 4, 0, 0, 4],
									movements: [
										{
											from: 3,
											to: null,
											face: '9s',
											diceRow: 3,
											faceIndex: 2,
											type: 'removed',
										},
										{
											from: 5,
											to: null,
											face: '9h',
											diceRow: 8,
											faceIndex: 2,
											type: 'removed',
										},
										{
											from: 6,
											to: null,
											face: '9c',
											diceRow: 6,
											faceIndex: 3,
											type: 'removed',
										},
										{
											from: 0,
											to: null,
											face: '5c',
											diceRow: 0,
											faceIndex: 2,
											type: 'removed',
										},
										{
											from: 4,
											to: null,
											face: '5h',
											diceRow: 7,
											faceIndex: 1,
											type: 'removed',
										},
										{
											from: null,
											to: 6,
											face: '3h',
											diceRow: 6,
											faceIndex: 0,
											type: 'spawned',
										},
										{
											from: null,
											to: 3,
											face: '9s',
											diceRow: 3,
											faceIndex: 2,
											type: 'spawned',
										},
										{
											from: null,
											to: 0,
											face: 'Js',
											diceRow: 0,
											faceIndex: 4,
											type: 'spawned',
										},
										{
											from: 1,
											to: 4,
											face: '3d',
											diceRow: 4,
											faceIndex: 2,
											type: 'moved',
										},
										{
											from: null,
											to: 1,
											face: 'Jc',
											diceRow: 1,
											faceIndex: 4,
											type: 'spawned',
										},
										{
											from: 2,
											to: 5,
											face: '8d',
											diceRow: 5,
											faceIndex: 4,
											type: 'moved',
										},
										{
											from: null,
											to: 2,
											face: '9d',
											diceRow: 2,
											faceIndex: 3,
											type: 'spawned',
										},
									],
									payout: 15,
									name: 'full-house',
									goalCode: 7,
								},
								{
									round: 3,
									blownIndexes: [0, 1, 8, 2, 3],
									beforeFaces: ['Js', 'Jc', '9d', '9s', '3d', '8d', '3h', '2h', 'Jh'],
									beforeIndexes: [4, 4, 3, 2, 2, 4, 0, 0, 4],
									afterFaces: ['4c', '2d', 'Ah', '9c', '3d', 'Kc', '3h', '2h', '8d'],
									afterIndexes: [1, 0, 5, 3, 2, 5, 0, 0, 4],
									movements: [
										{
											from: 0,
											to: null,
											face: 'Js',
											diceRow: 6,
											faceIndex: 4,
											type: 'removed',
										},
										{
											from: 1,
											to: null,
											face: 'Jc',
											diceRow: 4,
											faceIndex: 4,
											type: 'removed',
										},
										{
											from: 8,
											to: null,
											face: 'Jh',
											diceRow: 8,
											faceIndex: 4,
											type: 'removed',
										},
										{
											from: 2,
											to: null,
											face: '9d',
											diceRow: 8,
											faceIndex: 3,
											type: 'removed',
										},
										{
											from: 3,
											to: null,
											face: '9s',
											diceRow: 0,
											faceIndex: 2,
											type: 'removed',
										},
										{
											from: null,
											to: 3,
											face: '9c',
											diceRow: 3,
											faceIndex: 3,
											type: 'spawned',
										},
										{
											from: null,
											to: 0,
											face: '4c',
											diceRow: 0,
											faceIndex: 1,
											type: 'spawned',
										},
										{
											from: null,
											to: 1,
											face: '2d',
											diceRow: 1,
											faceIndex: 0,
											type: 'spawned',
										},
										{
											from: 5,
											to: 8,
											face: '8d',
											diceRow: 2,
											faceIndex: 4,
											type: 'moved',
										},
										{
											from: null,
											to: 5,
											face: 'Kc',
											diceRow: 5,
											faceIndex: 5,
											type: 'spawned',
										},
										{
											from: null,
											to: 2,
											face: 'Ah',
											diceRow: 2,
											faceIndex: 5,
											type: 'spawned',
										},
									],
									payout: 15,
									name: 'full-house',
									goalCode: 7,
								},
							],
							finalPayout: 40,
							finalFaces: ['4c', '2d', 'Ah', '9c', '3d', 'Kc', '3h', '2h', '8d'],
							finalIndexes: [1, 0, 5, 3, 2, 5, 0, 0, 4],
						},
						{
							rounds: [
								{
									round: 1,
									blownIndexes: [7, 3, 1, 5, 2],
									beforeFaces: ['6d', 'Yj', '6s', '9s', 'Th', 'Xj', 'Ac', 'Ts', '9h'],
									beforeIndexes: [3, 0, 2, 2, 3, 0, 5, 3, 2],
									afterFaces: ['3h', 'Qd', '7h', '6d', 'Ts', 'Kc', 'Ac', 'Th', '9h'],
									afterIndexes: [0, 4, 3, 3, 3, 5, 5, 3, 2],
									movements: [
										{
											from: 7,
											to: null,
											face: 'Ts',
											diceRow: 4,
											faceIndex: 3,
											type: 'removed',
										},
										{
											from: 3,
											to: null,
											face: '9s',
											diceRow: 6,
											faceIndex: 2,
											type: 'removed',
										},
										{
											from: 1,
											to: null,
											face: 'Yj',
											diceRow: 7,
											faceIndex: 0,
											type: 'removed',
										},
										{
											from: 5,
											to: null,
											face: 'Xj',
											diceRow: 2,
											faceIndex: 0,
											type: 'removed',
										},
										{
											from: 2,
											to: null,
											face: '6s',
											diceRow: 8,
											faceIndex: 2,
											type: 'removed',
										},
										{
											from: 0,
											to: 3,
											face: '6d',
											diceRow: 3,
											faceIndex: 3,
											type: 'moved',
										},
										{
											from: null,
											to: 0,
											face: '3h',
											diceRow: 0,
											faceIndex: 0,
											type: 'spawned',
										},
										{
											from: 4,
											to: 7,
											face: 'Th',
											diceRow: 1,
											faceIndex: 3,
											type: 'moved',
										},
										{
											from: null,
											to: 4,
											face: 'Ts',
											diceRow: 4,
											faceIndex: 3,
											type: 'spawned',
										},
										{
											from: null,
											to: 1,
											face: 'Qd',
											diceRow: 1,
											faceIndex: 4,
											type: 'spawned',
										},
										{
											from: null,
											to: 5,
											face: 'Kc',
											diceRow: 5,
											faceIndex: 5,
											type: 'spawned',
										},
										{
											from: null,
											to: 2,
											face: '7h',
											diceRow: 2,
											faceIndex: 3,
											type: 'spawned',
										},
									],
									payout: 60,
									name: 'straight-flush',
									goalCode: 11,
								},
							],
							finalPayout: 60,
							finalFaces: ['3h', 'Qd', '7h', '6d', 'Ts', 'Kc', 'Ac', 'Th', '9h'],
							finalIndexes: [0, 4, 3, 3, 3, 5, 5, 3, 2],
						},
						{
							rounds: [
								{
									round: 1,
									blownIndexes: [7, 1, 2, 4, 6],
									beforeFaces: ['Ad', 'Yj', '9d', '2s', '8c', '8d', '7s', 'Jc', 'Kc'],
									beforeIndexes: [5, 0, 3, 0, 2, 4, 2, 4, 5],
									afterFaces: ['Ac', '6h', '5s', 'Ad', '8c', '8d', '2s', '8h', 'Kc'],
									afterIndexes: [5, 3, 0, 5, 2, 4, 0, 2, 5],
									movements: [
										{
											from: 7,
											to: null,
											face: 'Jc',
											diceRow: 7,
											faceIndex: 4,
											type: 'removed',
										},
										{
											from: 1,
											to: null,
											face: 'Yj',
											diceRow: 1,
											faceIndex: 0,
											type: 'removed',
										},
										{
											from: 2,
											to: null,
											face: '9d',
											diceRow: 5,
											faceIndex: 3,
											type: 'removed',
										},
										{
											from: 4,
											to: null,
											face: '8c',
											diceRow: 4,
											faceIndex: 2,
											type: 'removed',
										},
										{
											from: 6,
											to: null,
											face: '7s',
											diceRow: 0,
											faceIndex: 2,
											type: 'removed',
										},
										{
											from: 3,
											to: 6,
											face: '2s',
											diceRow: 6,
											faceIndex: 0,
											type: 'moved',
										},
										{
											from: 0,
											to: 3,
											face: 'Ad',
											diceRow: 3,
											faceIndex: 5,
											type: 'moved',
										},
										{
											from: null,
											to: 0,
											face: 'Ac',
											diceRow: 0,
											faceIndex: 5,
											type: 'spawned',
										},
										{
											from: null,
											to: 7,
											face: '8h',
											diceRow: 7,
											faceIndex: 2,
											type: 'spawned',
										},
										{
											from: null,
											to: 4,
											face: '8c',
											diceRow: 4,
											faceIndex: 2,
											type: 'spawned',
										},
										{
											from: null,
											to: 1,
											face: '6h',
											diceRow: 1,
											faceIndex: 3,
											type: 'spawned',
										},
										{
											from: null,
											to: 2,
											face: '5s',
											diceRow: 2,
											faceIndex: 0,
											type: 'spawned',
										},
									],
									payout: 10,
									name: 'straight',
									goalCode: 5,
								},
								{
									round: 2,
									blownIndexes: [4, 5, 7, 0, 3],
									beforeFaces: ['Ac', '6h', '5s', 'Ad', '8c', '8d', '2s', '8h', 'Kc'],
									beforeIndexes: [5, 3, 0, 5, 2, 4, 0, 2, 5],
									afterFaces: ['6d', 'Th', '8d', '4c', '7d', '5s', '2s', '6h', 'Kc'],
									afterIndexes: [3, 3, 4, 1, 1, 0, 0, 3, 5],
									movements: [
										{
											from: 4,
											to: null,
											face: '8c',
											diceRow: 1,
											faceIndex: 2,
											type: 'removed',
										},
										{
											from: 5,
											to: null,
											face: '8d',
											diceRow: 2,
											faceIndex: 4,
											type: 'removed',
										},
										{
											from: 7,
											to: null,
											face: '8h',
											diceRow: 4,
											faceIndex: 2,
											type: 'removed',
										},
										{
											from: 0,
											to: null,
											face: 'Ac',
											diceRow: 6,
											faceIndex: 5,
											type: 'removed',
										},
										{
											from: 3,
											to: null,
											face: 'Ad',
											diceRow: 0,
											faceIndex: 5,
											type: 'removed',
										},
										{
											from: null,
											to: 3,
											face: '4c',
											diceRow: 3,
											faceIndex: 1,
											type: 'spawned',
										},
										{
											from: null,
											to: 0,
											face: '6d',
											diceRow: 0,
											faceIndex: 3,
											type: 'spawned',
										},
										{
											from: 1,
											to: 7,
											face: '6h',
											diceRow: 7,
											faceIndex: 3,
											type: 'moved',
										},
										{
											from: null,
											to: 4,
											face: '7d',
											diceRow: 4,
											faceIndex: 1,
											type: 'spawned',
										},
										{
											from: null,
											to: 1,
											face: 'Th',
											diceRow: 1,
											faceIndex: 3,
											type: 'spawned',
										},
										{
											from: 2,
											to: 5,
											face: '5s',
											diceRow: 5,
											faceIndex: 0,
											type: 'moved',
										},
										{
											from: null,
											to: 2,
											face: '8d',
											diceRow: 2,
											faceIndex: 4,
											type: 'spawned',
										},
									],
									payout: 15,
									name: 'full-house',
									goalCode: 7,
								},
								{
									round: 3,
									blownIndexes: [2, 4, 0, 5, 3],
									beforeFaces: ['6d', 'Th', '8d', '4c', '7d', '5s', '2s', '6h', 'Kc'],
									beforeIndexes: [3, 3, 4, 1, 1, 0, 0, 3, 5],
									afterFaces: ['Tc', '2c', '5s', '3h', 'Th', '3c', '2s', '6h', 'Kc'],
									afterIndexes: [3, 1, 0, 0, 3, 0, 0, 3, 5],
									movements: [
										{
											from: 2,
											to: null,
											face: '8d',
											diceRow: 8,
											faceIndex: 4,
											type: 'removed',
										},
										{
											from: 4,
											to: null,
											face: '7d',
											diceRow: 7,
											faceIndex: 1,
											type: 'removed',
										},
										{
											from: 0,
											to: null,
											face: '6d',
											diceRow: 6,
											faceIndex: 3,
											type: 'removed',
										},
										{
											from: 5,
											to: null,
											face: '5s',
											diceRow: 2,
											faceIndex: 0,
											type: 'removed',
										},
										{
											from: 3,
											to: null,
											face: '4c',
											diceRow: 0,
											faceIndex: 1,
											type: 'removed',
										},
										{
											from: null,
											to: 3,
											face: '3h',
											diceRow: 3,
											faceIndex: 0,
											type: 'spawned',
										},
										{
											from: null,
											to: 0,
											face: 'Tc',
											diceRow: 0,
											faceIndex: 3,
											type: 'spawned',
										},
										{
											from: 1,
											to: 4,
											face: 'Th',
											diceRow: 4,
											faceIndex: 3,
											type: 'moved',
										},
										{
											from: null,
											to: 1,
											face: '2c',
											diceRow: 1,
											faceIndex: 1,
											type: 'spawned',
										},
										{
											from: null,
											to: 5,
											face: '3c',
											diceRow: 5,
											faceIndex: 0,
											type: 'spawned',
										},
										{
											from: null,
											to: 2,
											face: '5s',
											diceRow: 2,
											faceIndex: 0,
											type: 'spawned',
										},
									],
									payout: 10,
									name: 'straight',
									goalCode: 5,
								},
							],
							finalPayout: 35,
							finalFaces: ['Tc', '2c', '5s', '3h', 'Th', '3c', '2s', '6h', 'Kc'],
							finalIndexes: [3, 1, 0, 0, 3, 0, 0, 3, 5],
						},
					],
					accumulativePayout: 135,
				},
				bonusGamePrizeAmount: 135,
				matchHand: [1, 4, 5, 7],
				goal: {
					goalCode: 8,
					goal: 'four-of-a-kind',
				},
			});
		}; */
		/* if (window.location.hostname === 'localhost') {		// 4 of 5 anticip
			return Promise.resolve({
				stakeAmount: 10,
				startedAt: 1772560009788,
				bonusGamePattern: {
					pattern: [1, 3, 4, 5, 7],
					createdAt: 1763565001848,
					id: 'ec81b655-fa41-4956-9382-f2a0561e141b',
					order: 1,
					updatedAt: 1763565001848,
				},
				deck: {
					faces: ['6d', 'Yj', '3c', 'Kd', '2d', 'Xj', 'Ac', 'Kh', 'Kc'],
					indexes: [3, 0, 0, 5, 0, 0, 5, 5, 5],
				},
				remainingRolls: 0,
				result: 'win',
				prizeAmount: 100,
				matchHand: [1, 5, 3, 7, 8],
				goal: {
					goalCode: 22,
					goal: 'five-of-a-kind',
				},
			});
		} */
		/* if(window.location.hostname === 'localhost') {
			return Promise.resolve({
				"stakeAmount": 5000,
				"startedAt": 1774978622154,
				"bonusGamePattern": {
					"pattern": [1, 3, 4, 5, 7],
					"createdAt": 1763565001848,
					"id": "ec81b655-fa41-4956-9382-f2a0561e141b",
					"order": 1,
					"updatedAt": 1763565001848
				},
				"deck": {
					"faces": ["Js", "2c", "3c", "2s", "2d", "7h", "3h", "2h", "5s"],
					"indexes": [4, 1, 0, 0, 0, 3, 0, 0, 0]
				},
				"remainingRolls": 0,
				"result": "win",
				"prizeAmount": 20000,
				"bonusGameData": {
					"freeGamesData": [
					{
						"rounds": [],
						"finalPayout": 0,
						"finalFaces": ["3s", "Yj", "Jh", "9s", "Th", "6c", "Ac", "8h", "7c"],
						"finalIndexes": [0, 0, 4, 2, 3, 2, 5, 2, 1]
					},
					{
						"rounds": [
						{
							"round": 1,
							"blownIndexes": [4, 8, 1, 5, 3],
							"beforeFaces": [
							"3s",
							"Yj",
							"9d",
							"9s",
							"Ks",
							"Xj",
							"Ac",
							"2h",
							"Qs"
							],
							"beforeIndexes": [0, 0, 3, 2, 5, 0, 5, 0, 4],
							"afterFaces": [
							"3h",
							"8c",
							"8d",
							"3s",
							"7d",
							"9h",
							"Ac",
							"2h",
							"9d"
							],
							"afterIndexes": [0, 2, 4, 0, 1, 2, 5, 0, 3],
							"movements": [
							{
								"from": 4,
								"to": null,
								"face": "Ks",
								"diceRow": 1,
								"faceIndex": 5,
								"type": "removed"
							},
							{
								"from": 8,
								"to": null,
								"face": "Qs",
								"diceRow": 5,
								"faceIndex": 4,
								"type": "removed"
							},
							{
								"from": 1,
								"to": null,
								"face": "Yj",
								"diceRow": 7,
								"faceIndex": 0,
								"type": "removed"
							},
							{
								"from": 5,
								"to": null,
								"face": "Xj",
								"diceRow": 2,
								"faceIndex": 0,
								"type": "removed"
							},
							{
								"from": 3,
								"to": null,
								"face": "9s",
								"diceRow": 6,
								"faceIndex": 2,
								"type": "removed"
							},
							{
								"from": 0,
								"to": 3,
								"face": "3s",
								"diceRow": 3,
								"faceIndex": 0,
								"type": "moved"
							},
							{
								"from": null,
								"to": 0,
								"face": "3h",
								"diceRow": 0,
								"faceIndex": 0,
								"type": "spawned"
							},
							{
								"from": null,
								"to": 4,
								"face": "7d",
								"diceRow": 4,
								"faceIndex": 1,
								"type": "spawned"
							},
							{
								"from": null,
								"to": 1,
								"face": "8c",
								"diceRow": 1,
								"faceIndex": 2,
								"type": "spawned"
							},
							{
								"from": 2,
								"to": 8,
								"face": "9d",
								"diceRow": 8,
								"faceIndex": 3,
								"type": "moved"
							},
							{
								"from": null,
								"to": 5,
								"face": "9h",
								"diceRow": 5,
								"faceIndex": 2,
								"type": "spawned"
							},
							{
								"from": null,
								"to": 2,
								"face": "8d",
								"diceRow": 2,
								"faceIndex": 4,
								"type": "spawned"
							}
							],
							"payout": 30000,
							"name": "straight-flush",
							"goalCode": 11
						}
						],
						"finalPayout": 30000,
						"finalFaces": ["3h", "8c", "8d", "3s", "7d", "9h", "Ac", "2h", "9d"],
						"finalIndexes": [0, 2, 4, 0, 1, 2, 5, 0, 3]
					},
					{
						"rounds": [
						{
							"round": 1,
							"blownIndexes": [6, 7, 8, 5],
							"beforeFaces": [
							"4h",
							"Qc",
							"6s",
							"4c",
							"Qd",
							"Xj",
							"7s",
							"7d",
							"7c"
							],
							"beforeIndexes": [1, 5, 2, 1, 4, 0, 2, 1, 1],
							"afterFaces": [
							"3h",
							"8h",
							"8d",
							"4h",
							"Qc",
							"Qs",
							"4c",
							"Qd",
							"6s"
							],
							"afterIndexes": [0, 2, 4, 1, 5, 4, 1, 4, 2],
							"movements": [
							{
								"from": 6,
								"to": null,
								"face": "7s",
								"diceRow": 0,
								"faceIndex": 2,
								"type": "removed"
							},
							{
								"from": 7,
								"to": null,
								"face": "7d",
								"diceRow": 1,
								"faceIndex": 1,
								"type": "removed"
							},
							{
								"from": 8,
								"to": null,
								"face": "7c",
								"diceRow": 5,
								"faceIndex": 1,
								"type": "removed"
							},
							{
								"from": 5,
								"to": null,
								"face": "Xj",
								"diceRow": 2,
								"faceIndex": 0,
								"type": "removed"
							},
							{
								"from": 3,
								"to": 6,
								"face": "4c",
								"diceRow": 6,
								"faceIndex": 1,
								"type": "moved"
							},
							{
								"from": 0,
								"to": 3,
								"face": "4h",
								"diceRow": 3,
								"faceIndex": 1,
								"type": "moved"
							},
							{
								"from": null,
								"to": 0,
								"face": "3h",
								"diceRow": 0,
								"faceIndex": 0,
								"type": "spawned"
							},
							{
								"from": 4,
								"to": 7,
								"face": "Qd",
								"diceRow": 7,
								"faceIndex": 4,
								"type": "moved"
							},
							{
								"from": 1,
								"to": 4,
								"face": "Qc",
								"diceRow": 4,
								"faceIndex": 5,
								"type": "moved"
							},
							{
								"from": null,
								"to": 1,
								"face": "8h",
								"diceRow": 1,
								"faceIndex": 2,
								"type": "spawned"
							},
							{
								"from": 2,
								"to": 8,
								"face": "6s",
								"diceRow": 8,
								"faceIndex": 2,
								"type": "moved"
							},
							{
								"from": null,
								"to": 5,
								"face": "Qs",
								"diceRow": 5,
								"faceIndex": 4,
								"type": "spawned"
							},
							{
								"from": null,
								"to": 2,
								"face": "8d",
								"diceRow": 2,
								"faceIndex": 4,
								"type": "spawned"
							}
							],
							"payout": 20000,
							"name": "four-of-a-kind",
							"goalCode": 8
						},
						{
							"round": 2,
							"blownIndexes": [4, 5, 7, 1, 2],
							"beforeFaces": [
							"3h",
							"8h",
							"8d",
							"4h",
							"Qc",
							"Qs",
							"4c",
							"Qd",
							"6s"
							],
							"beforeIndexes": [0, 2, 4, 1, 5, 4, 1, 4, 2],
							"afterFaces": [
							"3h",
							"7d",
							"Kc",
							"4h",
							"6h",
							"3c",
							"4c",
							"Th",
							"6s"
							],
							"afterIndexes": [0, 1, 5, 1, 3, 0, 1, 3, 2],
							"movements": [
							{
								"from": 4,
								"to": null,
								"face": "Qc",
								"diceRow": 4,
								"faceIndex": 5,
								"type": "removed"
							},
							{
								"from": 5,
								"to": null,
								"face": "Qs",
								"diceRow": 2,
								"faceIndex": 4,
								"type": "removed"
							},
							{
								"from": 7,
								"to": null,
								"face": "Qd",
								"diceRow": 7,
								"faceIndex": 4,
								"type": "removed"
							},
							{
								"from": 1,
								"to": null,
								"face": "8h",
								"diceRow": 1,
								"faceIndex": 2,
								"type": "removed"
							},
							{
								"from": 2,
								"to": null,
								"face": "8d",
								"diceRow": 8,
								"faceIndex": 4,
								"type": "removed"
							},
							{
								"from": null,
								"to": 7,
								"face": "Th",
								"diceRow": 7,
								"faceIndex": 3,
								"type": "spawned"
							},
							{
								"from": null,
								"to": 4,
								"face": "6h",
								"diceRow": 4,
								"faceIndex": 3,
								"type": "spawned"
							},
							{
								"from": null,
								"to": 1,
								"face": "7d",
								"diceRow": 1,
								"faceIndex": 1,
								"type": "spawned"
							},
							{
								"from": null,
								"to": 5,
								"face": "3c",
								"diceRow": 5,
								"faceIndex": 0,
								"type": "spawned"
							},
							{
								"from": null,
								"to": 2,
								"face": "Kc",
								"diceRow": 2,
								"faceIndex": 5,
								"type": "spawned"
							}
							],
							"payout": 7500,
							"name": "full-house",
							"goalCode": 7
						}
						],
						"finalPayout": 27500,
						"finalFaces": ["3h", "7d", "Kc", "4h", "6h", "3c", "4c", "Th", "6s"],
						"finalIndexes": [0, 1, 5, 1, 3, 0, 1, 3, 2]
					}
					],
					"accumulativePayout": 57500
				},
				"bonusGamePrizeAmount": 57500,
				"matchHand": [1, 3, 4, 7],
				"goal": {
					"goalCode": 8,
					"goal": "four-of-a-kind"
				}
			})
		} */

		return this.connection.CallRoute('mini-game-3', {
			betAmount: bet,
			bonusGamePatternId: patternId,
			//isRebet: rebet,
			//type: this.r7Data.gameId,
			mode: this.r7Data.casinoId
		});
	};

	GetMatch = (id) => {
		var payload = {
			MatchId: id,
		};

		var c = store.tutorialMode ? this.tutorialConnection : this.connection;

		return c.CallRoute('get-match', payload).then((data) => {
			if (data.ErrorCode) {
				return data;
			}
			data.Payload.Match.MatchId = id;
			if (data.Payload.Match.Opponents && data.Payload.Match.Opponents.length) {
				data.Payload.Match.OpponentMatchRounds = data.Payload.Match.Opponents[0].MatchRounds;
			}
			if (data.Payload.Match.Opponents.length && data.Payload.OpponentSummary) {
				data.Payload.Match.Opponents[0].summary = data.Payload.OpponentSummary;
			}
			return data;
		});
	};


	ContinueRoll = (held = []) => {
		/* if (window.location.hostname === 'localhost'){	// normal bonus
			store.slowNet(false);
			return Promise.resolve({
				deck: {
					faces: ['9c', 'Xj', '5h', '9s', '9d', 'Yj', '9h', 'Js', 'Kh'],
					indexes: [5, 3, 0, 4, 2, 4, 2, 0, 0],
				},
				remainingRolls: 0,
				result: 'win',
				prizeAmount: 7500,
				bonusGameData: {
					freeGamesData: [
						{
							rounds: [
								{
									round: 1,
									blownIndexes: [0, 4, 5, 2, 8],
									beforeFaces: ['Jd', '8d', 'Th', '4c', 'Jh', 'Yj', '7c', '3s', 'Ts'],
									beforeIndexes: [2, 2, 2, 3, 5, 4, 1, 4, 3],
									afterFaces: ['Qs', '6d', '8c', '4c', '8d', '8s', '7c', '3s', '8h'],
									afterIndexes: [0, 1, 4, 3, 2, 2, 1, 4, 2],
									movements: [
										{
											from: 0,
											to: null,
											face: 'Jd',
											diceRow: 3,
											faceIndex: 2,
											type: 'removed',
										},
										{
											from: 4,
											to: null,
											face: 'Jh',
											diceRow: 7,
											faceIndex: 5,
											type: 'removed',
										},
										{
											from: 5,
											to: null,
											face: 'Yj',
											diceRow: 5,
											faceIndex: 4,
											type: 'removed',
										},
										{
											from: 2,
											to: null,
											face: 'Th',
											diceRow: 2,
											faceIndex: 2,
											type: 'removed',
										},
										{
											from: 8,
											to: null,
											face: 'Ts',
											diceRow: 8,
											faceIndex: 3,
											type: 'removed',
										},
										{
											from: null,
											to: 0,
											face: 'Qs',
											diceRow: 0,
											faceIndex: 0,
											type: 'spawned',
										},
										{
											from: 1,
											to: 4,
											face: '8d',
											diceRow: 4,
											faceIndex: 2,
											type: 'moved',
										},
										{
											from: null,
											to: 1,
											face: '6d',
											diceRow: 1,
											faceIndex: 1,
											type: 'spawned',
										},
										{
											from: null,
											to: 8,
											face: '8h',
											diceRow: 8,
											faceIndex: 2,
											type: 'spawned',
										},
										{
											from: null,
											to: 5,
											face: '8s',
											diceRow: 5,
											faceIndex: 2,
											type: 'spawned',
										},
										{
											from: null,
											to: 2,
											face: '8c',
											diceRow: 2,
											faceIndex: 4,
											type: 'spawned',
										},
									],
									payout: 7500,
									name: 'full-house',
									goalCode: 7,
								},
							],
							finalPayout: 7500,
							finalFaces: ['Qs', '6d', '8c', '4c', '8d', '8s', '7c', '3s', '8h'],
							finalIndexes: [0, 1, 4, 3, 2, 2, 1, 4, 2],
						},
						{
							rounds: [],
							finalPayout: 0,
							finalFaces: ['9c', '6c', 'Th', '4c', 'As', 'Yj', 'Td', '3s', '8h'],
							finalIndexes: [5, 4, 2, 3, 0, 4, 4, 4, 2],
						},
						{
							rounds: [
								{
									round: 1,
									blownIndexes: [3, 5, 6, 4, 7],
									beforeFaces: ['7s', '8d', '5h', 'Kd', 'Jh', 'Yj', 'Kc', 'Js', 'Ts'],
									beforeIndexes: [0, 2, 0, 2, 5, 4, 3, 0, 3],
									afterFaces: ['Kd', '4d', '7d', 'Qs', '3s', '5h', '7s', '8d', 'Ts'],
									afterIndexes: [2, 4, 4, 0, 4, 0, 0, 2, 3],
									movements: [
										{
											from: 3,
											to: null,
											face: 'Kd',
											diceRow: 0,
											faceIndex: 2,
											type: 'removed',
										},
										{
											from: 5,
											to: null,
											face: 'Yj',
											diceRow: 8,
											faceIndex: 4,
											type: 'removed',
										},
										{
											from: 6,
											to: null,
											face: 'Kc',
											diceRow: 3,
											faceIndex: 3,
											type: 'removed',
										},
										{
											from: 4,
											to: null,
											face: 'Jh',
											diceRow: 1,
											faceIndex: 5,
											type: 'removed',
										},
										{
											from: 7,
											to: null,
											face: 'Js',
											diceRow: 4,
											faceIndex: 0,
											type: 'removed',
										},
										{
											from: 0,
											to: 6,
											face: '7s',
											diceRow: 6,
											faceIndex: 0,
											type: 'moved',
										},
										{
											from: null,
											to: 3,
											face: 'Qs',
											diceRow: 3,
											faceIndex: 0,
											type: 'spawned',
										},
										{
											from: null,
											to: 0,
											face: 'Kd',
											diceRow: 0,
											faceIndex: 2,
											type: 'spawned',
										},
										{
											from: 1,
											to: 7,
											face: '8d',
											diceRow: 7,
											faceIndex: 2,
											type: 'moved',
										},
										{
											from: null,
											to: 4,
											face: '3s',
											diceRow: 4,
											faceIndex: 4,
											type: 'spawned',
										},
										{
											from: null,
											to: 1,
											face: '4d',
											diceRow: 1,
											faceIndex: 4,
											type: 'spawned',
										},
										{
											from: 2,
											to: 5,
											face: '5h',
											diceRow: 5,
											faceIndex: 0,
											type: 'moved',
										},
										{
											from: null,
											to: 2,
											face: '7d',
											diceRow: 2,
											faceIndex: 4,
											type: 'spawned',
										},
									],
									payout: 7500,
									name: 'full-house',
									goalCode: 7,
								},
							],
							finalPayout: 7500,
							finalFaces: ['Kd', '4d', '7d', 'Qs', '3s', '5h', '7s', '8d', 'Ts'],
							finalIndexes: [2, 4, 4, 0, 4, 0, 0, 2, 3],
						},
					],
					accumulativePayout: 15000,
				},
				bonusGamePrizeAmount: 15000,
				matchHand: [7, 1, 5, 3, 4],
				goal: {
					goalCode: 7,
					goal: 'full-house',
				},
		})}; */

		/* if (window.location.hostname === 'localhost'){	// zero bonus
			store.slowNet(false);
			return Promise.resolve({
				deck: {
					faces: ['9c', 'Xj', '5h', '9s', '9d', 'Yj', '9h', 'Js', 'Kh'],
					indexes: [5, 3, 0, 4, 2, 4, 2, 0, 0],
				},
				remainingRolls: 0,
				result: 'win',
				prizeAmount: 7500,
				bonusGameData: {
					freeGamesData: [
						{
							rounds: [],
							finalPayout: 0,
							finalFaces: ['Qs', '6d', '8c', '4c', '8d', '8s', '7c', '3s', '8h'],
							finalIndexes: [0, 1, 4, 3, 2, 2, 1, 4, 2],
						},
						{
							rounds: [],
							finalPayout: 0,
							finalFaces: ['9c', '6c', 'Th', '4c', 'As', 'Yj', 'Td', '3s', '8h'],
							finalIndexes: [5, 4, 2, 3, 0, 4, 4, 4, 2],
						},
						{
							rounds: [],
							finalPayout: 0,
							finalFaces: ['Kd', '4d', '7d', 'Qs', '3s', '5h', '7s', '8d', 'Ts'],
							finalIndexes: [2, 4, 4, 0, 4, 0, 0, 2, 3],
						},
					],
					accumulativePayout: 0,
				},
				bonusGamePrizeAmount: 0,
				matchHand: [7, 1, 5, 3, 4],
				goal: {
					goalCode: 7,
					goal: 'full-house',
				},
		})}; */

		return this.connection.CallRoute('roll-dice', {
			holdIndexes: held,
		});
	};
	CompleteHand(id, selection) {
		var payload = {
			MatchId: id,
		};
		var c = store.tutorialMode ? this.tutorialConnection : this.connection;
		return c.CallRoute('keep-hand', payload);
	}

	UseFreeRoll(matchId) {
		var c = store.tutorialMode ? this.tutorialConnection : this.connection;
		return c.CallRoute('apply-free-roll', {
			MatchId: matchId,
		});
	}
	UseHandReset(matchId) {
		return this.connection.CallRoute('apply-hand-reset', {
			MatchId: matchId,
		});
	}
}
